import UserPublicationPinRecord from "models/view-models/user-publication-pin-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface UserPublicationPinPathParams {
    userId: number;
    notebookId: number;
}

export interface UserPublicationPinQueryParams {
    userId?: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "users/:userId/pins/notebooks/:notebookId/publications";
const resourceEndpoint = `${baseEndpoint}/:id`;
const resourceType = UserPublicationPinRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const UserPublicationPinService = {
    list: ServiceFactory.nestedList<
        UserPublicationPinRecord,
        UserPublicationPinPathParams,
        UserPublicationPinQueryParams
    >(resourceType, baseEndpoint),
    useList: ServiceHookFactory.useNestedList<
        UserPublicationPinRecord,
        UserPublicationPinPathParams,
        UserPublicationPinQueryParams
    >(resourceType, baseEndpoint),
    create: ServiceFactory.nestedCreate<
        UserPublicationPinRecord,
        UserPublicationPinPathParams
    >(resourceType, baseEndpoint),
    useCreate: ServiceHookFactory.useNestedCreate<
        UserPublicationPinRecord,
        UserPublicationPinPathParams
    >(resourceType, baseEndpoint),
    delete: ServiceFactory.delete<UserPublicationPinPathParams>(
        resourceEndpoint
    ),
    useDelete:
        ServiceHookFactory.useDelete<UserPublicationPinPathParams>(
            resourceEndpoint
        ),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default UserPublicationPinService;

// #endregion Exports
